export const DJ_TITLE = 'BE THE DJ';
export const DJ_CTA_MESSAGE = 'Select Up To 5 Songs!';